import React from 'react';
import styled from '@emotion/styled';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Title } from '../Typography/Title';

const Container = styled.div`
  display: flex;
  padding: 35px 40px;
  justify-content: space-between;
  background: rgba(240, 245, 255, 1);
`;

type Props = {
  onBack?: (e: any) => void;
  title: string;
  children: React.ReactNode;
  className?: any;
};
const PageHeader = ({ className, onBack, title, children }: Props) => {
  return (
    <Container className={className}>
      {onBack ? (
        <Button onClick={onBack} type="text" ghost icon={<ArrowLeftOutlined />}>
          <span>
            <Title level={5}>{title}</Title>
          </span>
        </Button>
      ) : (
        <Title level={3}>{title}</Title>
      )}
      {children}
    </Container>
  );
};

export default PageHeader;
